/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import PriceTable from "./PriceTable.container";

export default PriceTable;
